import React, {useEffect, useRef} from "react";
import close from '@uswds/uswds/img/sprite.svg';
import {Button} from "components/ui";
import propTypes from 'prop-types';
import styled from "styled-components";

const getChildrenByDisplayName = (children, displayName) => 
React.Children.map(children, (child) => 
    child.type.displayName === displayName ? child : null
);
  const Modal = ({modalId, children,...rest})=>{ 
    const modalHeader = getChildrenByDisplayName(children, 'Header'); 
    const modalButton = getChildrenByDisplayName(children, 'Button'); 
    const modalBody = getChildrenByDisplayName(children, 'Body'); 
    const modalFooter = getChildrenByDisplayName(children, 'Footer') 
    const modalRef=useRef(); 
      useEffect(() => { 
        let count = 1;
        document.body.addEventListener('keydown', e => { 
          if (e.key !== 'Tab' ) {
             return 
            } 
          if(modalRef && rest.modalDisplay) { 
            console.log(`Counter: ${count}`) 
            let focusableElements=`#${modalId} button, #${modalId} a[href]`; 
            let firstFocusableElement=document?.querySelector(`#${modalId}`)?.querySelectorAll(focusableElements)[0]; 
            let lastFocusableElement=document?.querySelector(`#${modalId}`)?.querySelectorAll(focusableElements)[document?.querySelector(`#${modalId}`)?.querySelectorAll(focusableElements).length-1]; 
            if(count === 1) { 
              firstFocusableElement?.focus() 
              e.preventDefault() 
              count++ 
            } 
            if(document.activeElement === lastFocusableElement) { 
              firstFocusableElement?.focus() 
              e.preventDefault() 
              count = 2 
            } 
          }
        })}, [rest.modalDisplay])
const ModalWrapper = styled.div`
display: ${props => props.modalDisplay ? "block": "none"};
position: fixed;
z-index: 500;
width: 90%;
margin: 0 auto;
@media (max-width: 1300px) and (min-width: 1100px) {
  top: ${props => props.modalType === "usa-modal--lg" ? "5%" : "5%"};
  left: ${props => props.modalType === "usa-modal--lg" ? "15%" : "15%"}; 
}
@media (max-width: 1100px) and (min-width: 200px) {
  top: ${props => props.modalType === "usa-modal--lg" ? "5%" : "10%"};
  left: ${props => props.modalType === "usa-modal--lg" ? "5%" : "5%"}; 
  max-height: 600px;
  overflow-y: scroll;
} 
@media (min-width: 1300px){
  top: ${props => props.modalType === "usa-modal--lg" ? "5%" : "5%"};
  left: ${props => props.modalType === "usa-modal--lg" ? "25%" : "25%"}; 
}
.usa-modal__content{
  padding-top: 0;
  p{
    margin: 0;
  }
}
.usa-modal__heading{
  h2{
      padding: 0;
    }
  text-align: center;
  color: ${props => props.headerTextColor};
  background-color: ${props => props.headerBgColor};
  padding: 1rem 0;
  margin-bottom: 0;
}
.usa-modal__close{
  padding: 0;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 101;
  color: ${props => props.closeColor};
}`;
return (
  <div ref={modalRef}>
  <ModalWrapper
  className={`usa-modal ${rest.modalType} margin-0 border radius-0 ${rest.modalDisplay && 'is-visible'}`}
  id={modalId}
  aria-labelledby={modalId}
  modalDisplay={rest.modalDisplay}
  modalType={rest.modalType}
  headerBgColor={rest.headerBgColor}
  closeColor={rest.closeColor}
  headerTextColor={rest.headerTextColor}
  >
    {modalHeader}
    {modalButton}
    {modalBody}
    {modalFooter}
  </ModalWrapper>
  </div>
)}
const ModalHeader = ({headerId, children}) => <div className="usa-modal__heading"id={headerId}>{children}</div>
ModalHeader.displayName = "Header";
Modal.ModalHeader = ModalHeader;

const ModalButton = ({closeModal}) => <Button btnType="usa-button usa-modal__close" closeModal={true} labelText="Close this window" onClick={closeModal}>
  <svg className="usa-icon" aria-hidden="true" focusable="false" role="img">
    <use xlinkHref={`${close}#close`}></use>
  </svg>
</Button>;
ModalButton.displayName = "Button";
Modal.ModalButton = ModalButton;

const ModalBody = ({modalBodyClass, children}) =>  <div className={`usa-modal__content ${modalBodyClass}`}>{children}</div>;
ModalBody.displayName = "Body";
Modal.ModalBody = ModalBody;

const ModalFooter =({modalFooterClass, children})=>  <div className={`usa-modal__footer ${modalFooterClass}`}>{children}</div>;
ModalFooter.displayName = "Footer";
Modal.ModalFooter = ModalFooter;

export default Modal;

Modal.propTypes = { 
  modalId: propTypes.string,
  modalType: propTypes.string,
  closeColor: propTypes.string,
  headerTextColor: propTypes.string,
  headerBgColor: propTypes.string,
  modalDisplay: propTypes.oneOf([true, false])
}
Modal.defaultProps = {
  modalId: '',
  modalType: '',
  closeColor: '#757575',
  headerTextColor: '#000',
  headerBgColor: '#fff',
  modalDisplay: false
}